import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

export const RECAPTCHA_V3_CONFIGURATION = {
  provide: RECAPTCHA_V3_SITE_KEY,
  useValue: '6LcHZSIeAAAAAK-Q_usZJmVfKokdWvIVYlKPiBdA'
};
